import { render, staticRenderFns } from "./AdminEnseigneForm.vue?vue&type=template&id=56d8bf00"
import script from "./AdminEnseigneForm.vue?vue&type=script&lang=ts"
export * from "./AdminEnseigneForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports